import {
  LIST_DIAGNOSTICS_REQUEST,
  LIST_DIAGNOSTICS_SUCCESS,
  LIST_DIAGNOSTICS_ERROR,
  GET_DIAGNOSTIC_REQUEST,
  GET_DIAGNOSTIC_SUCCESS,
  GET_DIAGNOSTIC_ERROR,
  ADD_DIAGNOSTIC_REQUEST,
  ADD_DIAGNOSTIC_SUCCESS,
  ADD_DIAGNOSTIC_ERROR,
  EDIT_DIAGNOSTIC_REQUEST,
  EDIT_DIAGNOSTIC_SUCCESS,
  EDIT_DIAGNOSTIC_ERROR,
  DELETE_DIAGNOSTIC_REQUEST,
  DELETE_DIAGNOSTIC_SUCCESS,
  DELETE_DIAGNOSTIC_ERROR,
  LINK_DIAGNOSTIC_SUBJECTS_REQUEST,
  LINK_DIAGNOSTIC_SUBJECTS_SUCCESS,
  LINK_DIAGNOSTIC_SUBJECTS_ERROR,
  GET_DIAGNOSTIC_SUBJECTS_REQUEST,
  GET_DIAGNOSTIC_SUBJECTS_SUCCESS,
  GET_DIAGNOSTIC_SUBJECTS_ERROR,
} from '../actions';

export const listDiagnosticsRequest = () => ({
  type: LIST_DIAGNOSTICS_REQUEST,
});
export const listDiagnosticsSuccess = (data) => ({
  type: LIST_DIAGNOSTICS_SUCCESS,
  payload: data,
});
export const listDiagnosticsError = (message) => ({
  type: LIST_DIAGNOSTICS_ERROR,
  payload: { message },
});

export const getDiagnosticRequest = (id) => ({
  type: GET_DIAGNOSTIC_REQUEST,
  payload: { id },
});
export const getDiagnosticSuccess = (data) => ({
  type: GET_DIAGNOSTIC_SUCCESS,
  payload: data,
});
export const getDiagnosticError = (message) => ({
  type: GET_DIAGNOSTIC_ERROR,
  payload: { message },
});

export const addDiagnosticRequest = (diagnostic) => ({
  type: ADD_DIAGNOSTIC_REQUEST,
  payload: { diagnostic },
});
export const addDiagnosticSuccess = (data) => ({
  type: ADD_DIAGNOSTIC_SUCCESS,
  payload: data,
});
export const addDiagnosticError = (message) => ({
  type: ADD_DIAGNOSTIC_ERROR,
  payload: { message },
});

export const editDiagnosticRequest = (diagnostic) => ({
  type: EDIT_DIAGNOSTIC_REQUEST,
  payload: { diagnostic },
});
export const editDiagnosticSuccess = (data) => ({
  type: EDIT_DIAGNOSTIC_SUCCESS,
  payload: data,
});
export const editDiagnosticError = (message) => ({
  type: EDIT_DIAGNOSTIC_ERROR,
  payload: { message },
});

export const deleteDiagnosticRequest = (id) => ({
  type: DELETE_DIAGNOSTIC_REQUEST,
  payload: { id },
});
export const deleteDiagnosticSuccess = (id) => ({
  type: DELETE_DIAGNOSTIC_SUCCESS,
  payload: { id },
});
export const deleteDiagnosticError = (message) => ({
  type: DELETE_DIAGNOSTIC_ERROR,
  payload: { message },
});

export const linkDiagnosticSubjectsRequest = (id, subjectIds) => ({
  type: LINK_DIAGNOSTIC_SUBJECTS_REQUEST,
  payload: { id, subjectIds },
});
export const linkDiagnosticSubjectsSuccess = () => ({
  type: LINK_DIAGNOSTIC_SUBJECTS_SUCCESS,
});
export const linkDiagnosticSubjectsError = (message) => ({
  type: LINK_DIAGNOSTIC_SUBJECTS_ERROR,
  payload: { message },
});

export const getDiagnosticSubjectsRequest = (id) => ({
  type: GET_DIAGNOSTIC_SUBJECTS_REQUEST,
  payload: { id },
});
export const getDiagnosticSubjectsSuccess = (data) => ({
  type: GET_DIAGNOSTIC_SUBJECTS_SUCCESS,
  payload: data,
});
export const getDiagnosticSubjectsError = (message) => ({
  type: GET_DIAGNOSTIC_SUBJECTS_ERROR,
  payload: { message },
});
